import { render, staticRenderFns } from "./CheckoutFormComponent.vue?vue&type=template&id=2070210f&"
import script from "./CheckoutFormComponent.vue?vue&type=script&lang=js&"
export * from "./CheckoutFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports